module.exports = __webpack_public_path__ + "static/img/LR-sverige.fa641f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/LR-sverige.png
// module id = Uaq7
// module chunks = 1